var map = {
	"./paper_file_2020_1.pdf": 1904,
	"./paper_file_2020_2.pdf": 7965,
	"./paper_file_2021_1.pdf": 6866,
	"./paper_file_2022_1.pdf": 7421,
	"./paper_file_2022_2.pdf": 3115,
	"./paper_file_2022_3.pdf": 3062,
	"./paper_file_2023_1.pdf": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2015;